<template>
  <div class="activity-scheduler-wrapper">
    <ActivityListComponent v-if="showActivityList" :participantData="participantData" @getSelectedActivities="getSelectedActivities" @cancelScheduling="cancelScheduling" :isManualStudyStart="isManualStudyStart" :participantStudyTrigger="participantStudyTrigger"></ActivityListComponent>
    <ActivitySelectorComponent
      v-else
      :selectedActivityList="selectedActivities"
      :scheduledActivityData="scheduledActivityData"
      :participantData="participantData"
      :isManualStudyStart="isManualStudyStart"
      :participantStudyTrigger="participantStudyTrigger"
      :studyVersionId="studyVersionId"
      @sendSelectedActivity="sendSelectedActivity"
      @cancelScheduling="cancelScheduling"
      :studyData="studyData"
      @showAllActivities="showAllActivities"
    ></ActivitySelectorComponent>
    <ActivitySchedulerComponent ref="activitySchedulerModal" :activity="selectedActivity" :participantData="participantData" @activityIsScheduled="activityIsScheduled"></ActivitySchedulerComponent>
  </div>
</template>
<script>
import ActivityListComponent from "./activity-list.vue";
import ActivitySelectorComponent from "./activity-selector.vue";
import ActivitySchedulerComponent from "./activity-scheduler.vue";
import swal from "sweetalert2";

export default {
  name: "ActivityManagementComponent",
  components: {
    ActivityListComponent,
    ActivitySelectorComponent,
    ActivitySchedulerComponent
  },
  props: {
    participantData: {
      type: Object,
      required: true
    },
    isManualStudyStart: {
      type: Boolean
    },
    participantStudyTrigger: {
      type: Boolean
    },
    studyVersionId: {
      type: String
    },
    studyData: {
      type: Object
    }
  },
  data() {
    return {
      showActivityList: true,
      selectedActivity: {},
      selectedActivities: [],
      scheduledActivityData: {}
    };
  },
  methods: {
    showAllActivities() {
      this.showActivityList = true;
    },
    getSelectedActivities(data) {
      this.showActivityList = false;
      this.selectedActivities = data && data.activities;
    },
    sendSelectedActivity(data) {
      this.selectedActivity = data.activity;
      this.$refs.activitySchedulerModal.show();
    },
    activityIsScheduled(data) {
      this.scheduledActivityData = data;
    },
    cancelScheduling(data) {
      if (data) {
        if (data.showActivityList) {
          this.showActivityList = true;
        } else if (data.showDoubleConfirmation) {
          swal({
            title: "Are you sure you would like to cancel?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#B8C7CE",
            cancelButtonColor: "#34537D",
            confirmButtonText: "Cancel",
            cancelButtonText: "Yes"
          }).then(({ dismiss }) => {
            if (dismiss === "cancel") {
              this.$emit("cancelOnDemandScheduling", null);
            }
          });
        } else {
          this.$emit("cancelOnDemandScheduling", null);
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.activity-scheduler-wrapper {
  margin: 8px 17px 0 17px;
}
</style>
